import axios from 'axios'

export default class PremiacaoMercado {
  constructor (tokenBearer, url, id) {
    this.url = `${url}/api/unimed/premiacoes`
    this.id = id
    this.tokenBearer = tokenBearer
  }

  getPremiacao (args) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/${this.id}?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  putPremiacao (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: `${this.url}/${this.id}`,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  deletePremiacao (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'delete',
        url: `${this.url}/${this.id}`,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
